import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ModeSelectionViewModel from "../../TripRate/ViewModels/ModeSelectionViewModel";

interface IProps {
    modes: ModeSelectionViewModel[];
    selectedMode: number | null;
    onSelectMode: (modeId: number) => void;
}

const modeDisplayOrder = [
    "Total Vehicles",
    "Servicing Vehicles",
    "Total People",
    "Cars",
    "Taxis",
    "Motorcycles",
    "LGVs",
    "PSVs",
    "OGVs",
    "Cyclists",
    "Scooters",
    "Vehicle Occupants",
    "Pedestrians",
    "Public Transport Users",
    "Bus/Tram Passengers",
    "Bus Passengers",
    "Tram Passengers",
    "Total Rail Passengers",
    "Underground Passengers",
    "Overground Passengers",
    "National Rail Passengers",
    "DLR Passengers",
    "Coach Passengers",
    "Water Service Passengers",
];

export default function TripRateSitesGraphModeSelection({ modes, selectedMode, onSelectMode }: IProps) {
    const selectableModes = modes
        .filter(mode => mode.isSelectable)
        .sort((first, second) => {
            const firstIndex = modeDisplayOrder.indexOf(first.modeName.replaceAll('"', ""));
            const secondIndex = modeDisplayOrder.indexOf(second.modeName.replaceAll('"', ""));
            const firstOrder = firstIndex === -1 ? modeDisplayOrder.length : firstIndex;
            const secondOrder = secondIndex === -1 ? modeDisplayOrder.length : secondIndex;

            return firstOrder - secondOrder;
        });

    return (
        <Stack spacing={2}>
            {selectableModes.length > 0 ? (
                <Grid container spacing={2} justifyContent="flex-start">
                    {selectableModes.map(mode => {
                        const isSelected = selectedMode === mode.modeId;

                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={mode.modeId}>
                                <Paper
                                    elevation={0}
                                    onClick={() => onSelectMode(mode.modeId)}
                                    sx={{
                                        cursor: "pointer",
                                        p: 2,
                                        height: "100%",
                                        border: "1px solid",
                                        borderColor: isSelected ? "primary.main" : "divider",
                                        bgcolor: isSelected ? "action.selected" : "background.paper",
                                        transition: "border-color 120ms ease, background-color 120ms ease",
                                        "&:hover": {
                                            borderColor: "primary.main",
                                            bgcolor: "action.hover",
                                        },
                                    }}
                                >
                                    <Stack spacing={1} alignItems="center" textAlign="center">
                                        <Avatar
                                            variant="rounded"
                                            src={`/Icons/${mode.modeIcon}`}
                                            sx={{
                                                width: 56,
                                                height: 56,
                                                bgcolor: isSelected ? "primary.main" : "grey.400",
                                            }}
                                        />
                                        <Box>
                                            <Typography variant="subtitle2">{mode.modeName}</Typography>
                                        </Box>
                                    </Stack>
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
            ) : (
                <Typography variant="body2">No selectable modes are available for this selection.</Typography>
            )}

        </Stack>
    );
}
